import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
} from '@material-ui/core'

const DialogDesk360 = ({ open, setOpen = () => {} }) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
  }, [open])

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box>
          <Typography variant="h4">Atendimento</Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        {loading && (
          <Box
            display="flex"
            width="100%"
            minHeight="700px"
            justifyContent="center"
            alignItems="center"
          >
            <CircularProgress />
          </Box>
        )}
        <Box>
          <iframe
            // trocar quando tiver o link da leavening
            src="https://superfin.tomticket.com/formulario?id=EP58547&account=3747008P09082022103158"
            frameBorder="0"
            title="desk360IFrame"
            width="100%"
            id="desk360IFrame"
            onLoad={() => setLoading(false)}
            height="800px"
          />
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          type="button"
          variant="outlined"
          onClick={() => setOpen(false)}
          component="a"
        >
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DialogDesk360.prototype = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
}

export default DialogDesk360
